webpackJsonp([42],{

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Position Title"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.humanize(item.type)))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete && item.type !== 'SystemManaged')?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"rolemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Role")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-role-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'policy' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-role-policy","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'policy'}}},[_c('span',{staticClass:"required"},[_vm._v("Permission")])])])]),_vm._v(" "),(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"identity-role-general"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.name.$error,
                              },attrs:{"type":"text"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.name.$error)?_c('div',[(!_vm.$v.model.name.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.name.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name must be less than\n                                "+_vm._s(_vm.$v.model.name.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desription")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.description),expression:"model.description"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.description.$error,
                              },attrs:{"rows":"4"},domProps:{"value":(_vm.model.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "description", $event.target.value)}}}),_vm._v(" "),(_vm.model.description)?_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                              "+_vm._s(_vm.model.description.length)+" /\n                              "+_vm._s(_vm.$v.model.description.$params.maxLength.max)+"\n                              characters\n                            ")]):_vm._e(),_vm._v(" "),(
                                _vm.isSubmitted && !_vm.$v.model.description.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Description must be less than\n                              "+_vm._s(_vm.$v.model.description.$params.maxLength.max)+"\n                              characters")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'policy' ? 'in active' : ''],attrs:{"id":"identity-role-policy"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},_vm._l((_vm.model.policies),function(item){return _c('label',{key:item.name,staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              "+_vm._s(item.name)+"\n                            ")])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])])])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Security")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Roles\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Roles\n                  "),_c('span',[_c('i',{staticClass:"ic-settings-horizontal"})])]),_vm._v(" "),_c('p',[_vm._v("Configure and manage user roles.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentityRole_vue__ = __webpack_require__(799);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5672aa4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentityRole_vue__ = __webpack_require__(1069);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentityRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5672aa4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentityRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/identityPolicies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/identityRoles';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllPredefined: function getAllPredefined() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/predefined').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityPolicyService_js__ = __webpack_require__(623);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      isSubmitted: false,
      activeTab: "general",
      allPermissions: [],
      policies: [],
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
        description: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(500) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 14;
                break;
              }

              _context.next = 13;
              return _this.getAll();

            case 13:
              _this.getPolicies();

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.rolemodal).on("hidden.bs.modal", this.closeModal);
  },
  updated: function updated() {
    this.$helper.collapseMenu("security");
    this.$helper.setNavigationClass("identity-role-link");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    resetModel: function resetModel() {
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal: function openModal(object) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
      $(this.$refs.rolemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal: function closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.rolemodal).modal("hide");
    },
    createItem: function createItem() {
      this.resetModel();
      this.openModal({ policies: [] });
      this.isUpdate = false;
      this.activeTab = "general";

      for (var i = 0; i < this.policies.length; i++) {
        this.model.policies.push({
          isSelected: false,
          id: this.policies[i].id,
          name: this.policies[i].name
        });
      }
    },
    updateItem: function updateItem(item) {
      var _this5 = this;

      this.openModal(item);
      this.isUpdate = true;
      this.activeTab = "general";
      this.model.policies = [];

      var _loop = function _loop(i) {
        var selectedPolicy = item.policies.find(function (x) {
          return x.id === _this5.policies[i].id;
        });
        _this5.model.policies.push({
          isSelected: selectedPolicy !== undefined && selectedPolicy !== null,
          id: _this5.policies[i].id,
          name: _this5.policies[i].name
        });
      };

      for (var i = 0; i < this.policies.length; i++) {
        _loop(i);
      }
    },
    getPolicies: function getPolicies() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityPolicyService_js__["a" /* default */].getAllActive();

              case 2:
                _this6.policies = _context6.sent;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getAll: function getAll() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this7.isLoading = true;
                filter = "?page=" + _this7.table.pageNumber + "&size=" + _this7.table.pageSize;

                if (_this7.table.keyword !== null && _this7.table.keyword !== "") {
                  filter += "&search=" + _this7.table.keyword;
                }
                _context7.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].getAll(filter);

              case 6:
                response = _context7.sent;

                _this7.items = response.data;
                _this7.table.totalPages = response.totalPages;
                _this7.table.totalRecords = response.totalRecords;
                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](0);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this7.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context7.prev = 15;

                _this7.isLoading = false;
                return _context7.finish(15);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 12, 15, 18]]);
      }))();
    },
    submit: function submit() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var selectedPolicies, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.isSubmitted = true;
                _this8.$v.model.$touch();

                if (!_this8.$v.model.$error) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                selectedPolicies = _this8.model.policies.filter(function (x) {
                  return x.isSelected;
                });

                if (!(selectedPolicies.length === 0)) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt("return");

              case 7:
                _context8.prev = 7;

                _this8.isLoading = true;
                _this8.model.policies = selectedPolicies.map(function (x) {
                  return x.id;
                });

                if (!_this8.isUpdate) {
                  _context8.next = 16;
                  break;
                }

                _context8.next = 13;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].update(_this8.model);

              case 13:
                _this8.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context8.next = 19;
                break;

              case 16:
                _context8.next = 18;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].create(_this8.model);

              case 18:
                _this8.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 19:
                _this8.$store.dispatch("user/removeProfile");
                _this8.getAll();
                _this8.closeModal();
                _context8.next = 27;
                break;

              case 24:
                _context8.prev = 24;
                _context8.t0 = _context8["catch"](7);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this8.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 27:
                _context8.prev = 27;

                _this8.isLoading = false;
                return _context8.finish(27);

              case 30:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[7, 24, 27, 30]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var updatedItem, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this9.isLoading = true;
                updatedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

                updatedItem.policies = item.policies.map(function (x) {
                  return x.id;
                });
                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].update(updatedItem);

              case 6:
                _this9.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _this9.$store.dispatch("user/removeProfile");
                _this9.getAll();
                _context9.next = 14;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this9.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context9.prev = 14;

                _this9.isLoading = false;
                return _context9.finish(14);

              case 17:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 11, 14, 17]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this10.isLoading = true;
                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].delete(_this10.itemToBeDeleted.id);

              case 4:
                _this10.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _this10.$store.dispatch("user/removeProfile");
                _this10.getAll();
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context10.prev = 12;

                _this10.isLoading = false;
                return _context10.finish(12);

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 9, 12, 15]]);
      }))();
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.41337ce83b7be0013253.js